// Resync depois de uma queda de socket.
//
// O Socket.IO **não reenvia** o que emitiu enquanto o socket esteve fora, e a
// tela não tinha nada que buscasse esse buraco: o atendente simplesmente parava
// de receber, sem erro nenhum na tela, até dar F5. Era o #14627 ("recarrego às
// 17h e aparecem mensagens de horas atrás") — a mensagem estava gravada no banco
// desde a hora certa, só não tinha chegado no navegador.
//
// Reconectar sozinho o socket.io já faz, e os componentes reentram na sala no
// `connect`, então mensagens novas voltam a chegar. O que falta é o intervalo.
//
// O primeiro `connect` é a conexão inicial, quando a tela já carregou por HTTP —
// só as reconexões precisam de resync.
export const aoReconectar = (socket, callback) => {
  let primeiraConexao = true;
  socket.on("connect", () => {
    if (primeiraConexao) {
      primeiraConexao = false;
      return;
    }
    callback();
  });
};
